import { ChangeDetectionStrategy, Compiler, Component, Inject, Injector, Input, OnInit, ReflectiveInjector } from '@angular/core';

import { MediaManagerComponent } from './media-manager.component';
import { GRID_ONLY } from './services/grid-only.token';

// This XXXPageComponent exists as a lazy-loading mechanism for a page's module while we
// are in MPA structure and cannot therefore use Angular's router.
@Component({
   selector: 'bb-media-manager-page',
   template: `
      <div *ngIf="loaded">
         <!-- Once loaded, instantiate the component (start the component tree here) -->
         <ng-container *ngComponentOutlet="component; injector: mamInjector"></ng-container>
      </div>
   `,
   styles: [':host { display: block; }'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class MediaManagerPageComponent implements OnInit {
   @Input() gridOnly: 'True' | null;
   public loaded = false;
   public component: typeof MediaManagerComponent;
   mamInjector: Injector;

   constructor(
      private compiler: Compiler,
      private injector: Injector,
   ) {}

   async ngOnInit() {
      // Inject values into ngComponentOutlet https://stackoverflow.com/a/48498602/5529781
      this.mamInjector = ReflectiveInjector.resolveAndCreate([{ provide: GRID_ONLY, useValue: this.gridOnly}], this.injector);
      /* Statically import the page's module.
       * This import() statement will be parsed by Angular's static analysis during the build and
       * generate the module bundle. Angular inserts the module script into the HTML at runtime
       * (does not appear as a script tag in our HTML, or in the dist index.html).
       * https://angular.io/guide/lazy-loading-ngmodules
       * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-4.html#dynamic-import-expressions
       */
      const { MediaManagerAppModule: module } = await import('./media-manager.app.module');
      // Grab the root component of the page's component tree
      this.component = module.rootComponent;
      const factory = await this.compiler.compileModuleAsync(module);
      // Instantiate the module with the Angular injector
      factory.create(this.injector);
      this.loaded = true;
   }
}
